import React from "react"
import { Link } from "gatsby"
import keeptab from "../../../images/keep-tab.png"
import StaticVideo from "../../Video/StaticVideo"
import PosterImage from "./../../../images/video-1-poster.png"
import Transcript from "./../../../images/Hero-Transcript.pdf"
import PDF from "./../../../images/EE-Beano-final-comic-book.pdf"
import "./BeanoKeepTabs.scss"


const BeanoKeepTabs = () => {
	return (
		<div className="keep-tabs-content">		
			<div className="content">
				<h3>Dennis & Gnasher</h3>
				<h2>A MINI BEANO ADVENTURE</h2>
				<p>Watch the video to join Dennis and Minnie as they jump head-first into the phone world, experiencing the ups and downs, and getting to grips with the dos and don’ts.</p>
				{/* <img src={keeptab} alt="Keep tabs on your kid's progress"/> */}
				<StaticVideo videoId="zWhd-SqTh4Q" poster={PosterImage} transcript={Transcript} engagement={"Grown-up Homepage"}/>
				<a href={PDF} className="btn btn-highlight" target="_blank" data-analytics='{"event":"download", "eventCategory":"Beano - Engagement", "eventAction":"CTA Click", "eventLabel":"Download the comic"}'>Download the comic</a>
			</div>
		</div>
	)
}

export default BeanoKeepTabs
